var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemContentFilledLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.988 16.998a4.97 4.97 0 0 0 3.527-1.459.999.999 0 1 0-1.414-1.414 2.99 2.99 0 0 1-4.226 0 2.993 2.993 0 0 1 0-4.227 2.99 2.99 0 0 1 4.226 0 .999.999 0 1 0 1.414-1.414 4.993 4.993 0 0 0-7.054 0 4.993 4.993 0 0 0 0 7.055 4.97 4.97 0 0 0 3.527 1.459"
}))));
export default SvgGemContentFilledLight;